<template>
  <div>
    <template v-if="loading">
        <div class="min-w-40 h-4 rounded-lg  bg-gray-200 animate-pulse border">

        </div>
    </template>
    <template v-else>

      <div class="public-text1 text-right ">
        <router-link
          :to="item.to"
          v-for="(item, index) in breadcrumbs"
          :key="index"
          :aria-label="item.text"
          :class="cat_length === index ? 'public-text1-b' : 'text-gray-500'"
          >{{ item.text }}<span v-if="cat_length !== index">/&nbsp;</span>
        </router-link>
      </div>
    </template>
  </div>
  </template>
  <script setup>
  import { defineProps, ref, onMounted } from "vue";
  import axios from "axios";
  const props = defineProps({
    category_slug: {
      require: true,
      type: String,
    },
  });
  const cat_length = ref(0);
  const category = ref("");
  const breadcrumbs = ref([]);
  const categories = ref([]);
  const loading=ref(false)
  const generateBreadcrumbs = (x) => {
    
    let currentCategory = x;
    if(x==='همه-محصولات'){
      cat_length.value += 1;
      breadcrumbs.value.unshift({
        text: 'همه محصولات',
        to: { name: "category", params: { name: 'همه-محصولات' } },
      });
      loading.value=false
    }else{
      while (currentCategory) {
      cat_length.value += 1;
      breadcrumbs.value.unshift({
        text: currentCategory.name,
        to: { name: "category", params: { name: currentCategory.slug } },
      });
      currentCategory = categories.value.find(
        (c) => c.id === currentCategory.sub_category
      );
    }
    }
   
    breadcrumbs.value.unshift({ text: "خانه", to: { name: "home" } });
    return breadcrumbs;
  };
  
  onMounted(async () => {
    loading.value=true
    if(props.category_slug==='همه-محصولات'){
      generateBreadcrumbs('همه-محصولات');
    }else{
      try {
      // const response=await store.dispatch("setCategoryFromApi")
      const { data } = await axios.post(
        "https://parsinekala.com/backend/api/categories/"
      );
      categories.value = data;
      data.forEach((element) => {
        if (element.slug === props.category_slug) {
          category.value = element;
        }
      });
    
      if (data !== null) {
        generateBreadcrumbs(category.value);
      } else {
        console.log("not fetch data");
      }
    } catch (e) {
      // console.log(e)
    }finally{
      loading.value=false
    }
    }
  });
  
  </script>